/* RESPONSIBLE TEAM: team-ai-agent */
import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class ChatWithYourDataIndexController extends Controller {
  queryParams = ['context'];

  @tracked context?: string;
}
